var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.$t('configManager.createNewDatabaseConfig'))+" ")]),_c('configure-config')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }